import React from 'react'
import Header from './Header'
import Routes from './Routes'
// import Footer from './Footer'
import { Container } from 'semantic-ui-react'

export default () => (
    <div>
        <div style={{
            position: 'sticky',
            top: 0,
            background: 'white',
            zIndex: '10'
        }}>
            <Header />
        </div>
        <Container style={{ minHeight: '219px' }}>
            <Routes />
        </Container>
        {/* <Footer /> */}
    </div >
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js